import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  Typography,
  Table,
  Button,
  Tag,
  Popconfirm,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import axiosNew, { baseURLNew } from "../../store/api/axiosNew";
import axios from "axios";

const { Title, Text } = Typography;

const RetailAdminDashboard = () => {
  const navigate = useNavigate();

  const [leads, setLeads] = useState([]);
  // const [filteredLeads, setFilteredLeads] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });

  const fetchAllLeads = async (page = 1, limit = 10, search = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");

      const res = await axiosNew.get(
        "https://stageapilead.blaccdot.com/api/admin/admin/leads",
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { page, limit, search },
        },
      );

      setLeads(res.data?.data || []);
      // setFilteredLeads(res.data?.data || []);
      setPagination({
        page: res.data?.page || page,
        limit: res.data?.limit || limit,
        total: res.data?.totalCount || 0,
      });
    } catch (error) {
      console.error("Failed to fetch admin leads", error);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  fetchAllLeads(1, pagination.limit, "");
}, []);

  const matchesSearch = (lead) => {
    const term = searchTerm.toLowerCase();
    if (!term) return true;

    // 1. Check nested object labels specifically
    const categoryLabel = lead.category?.label?.toLowerCase() || "";
    const subCategoryLabel = lead.subcategory?.label?.toLowerCase() || "";

    if (categoryLabel.includes(term) || subCategoryLabel.includes(term)) {
      return true;
    }

    // 2. Check all other fields (your original logic)
    return Object.entries(lead).some(([key, value]) => {
      if (!value || typeof value === "object") return false; // Skip objects here since we handled them above

      let stringValue = value.toString().toLowerCase();

      if (key === "createdAt") {
        stringValue = moment(value).format("DD-MM-YYYY").toLowerCase();
      }

      return stringValue.includes(term);
    });
  };

  const updateTopLead = async (leadId) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");
      await axiosNew.post(`${baseURLNew}leads/${leadId}/top`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchAllLeads(pagination.page, pagination.limit);
    } catch (err) {
      console.error("Failed to update top lead", err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   setFilteredLeads(leads.filter(matchesSearch));
  // }, [searchTerm, leads]);

  const columns = [
    {
      title: "LeadID",
      dataIndex: "newLeadId",
      width: 150,
      render: (text, record) => (
        <div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            {record.newLeadId}
          </div>
        </div>
      ),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 110,
      render: (date) => moment(date).format("DD-MM-YYYY"),
    },
    {
      title: "Lead Name",
      dataIndex: "name",
      width: 150,
      fixed: "left",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: "bold" }}>{text}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>{record.phone}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>{record.email}</div>
        </div>
      ),
    },
    {
      title: "Location",
      key: "location",
      // Width removed so this column expands to fill the Card's horizontal space
      render: (_, record) => (
        <div style={{ fontWeight: 500 }}>{record.location}</div>
      ),
    },
    {
      title: "Geography",
      key: "geography",
      // Width removed so this column expands to fill the Card's horizontal space
      render: (_, record) => (
        <div style={{ fontSize: "13px" }}>
          <div style={{ color: "#000000" }}>
            {record.area ? `${record.area}, ` : ""}
            {record.district ? `${record.district}, ` : ""}
            {record.state} - {record.pincode}
          </div>
        </div>
      ),
    },
    {
      title: "Category",
      key: "category",
      width: 160,
      render: (_, record) => (
        <div>
          <Tag color="blue">{record.category?.label}</Tag>
          <div style={{ fontSize: "12px", color: "#999", marginTop: 4 }}>
            {record.subcategory?.label}
          </div>
        </div>
      ),
    },
    {
      title: "Lead Specs",
      key: "specs",
      width: 180,
      render: (_, record) => (
        <div style={{ fontSize: "13px" }}>
          <div>
            <strong>Type:</strong>{" "}
            <Tag color="orange">{record.leadType?.toUpperCase()}</Tag>
          </div>
          <div>
            <strong>Purpose:</strong> <Tag color="cyan">{record.purpose}</Tag>
          </div>
          <div>
            <strong>Space:</strong> {record.spaceSqft} sqft
          </div>
        </div>
      ),
    },
    {
      title: "Property Details",
      key: "property_details",
      width: 180,
      render: (_, record) => (
        <div style={{ fontSize: "13px" }}>
          <div>
            <Tag color="orange">{record.property_details?.toUpperCase()}</Tag>
          </div>
        </div>
      ),
    },
    {
      title: "Budget",
      dataIndex: "budget",
      width: 130,
      render: (val) => (
        <span style={{ fontWeight: 600 }}>₹{val?.toLocaleString()}</span>
      ),
    },
    {
      title: "Inventory",
      key: "inventory",
      width: 150,
      render: (_, record) => (
        <div>
          <Tag color={record.availableCount > 0 ? "green" : "red"}>
            {record.availableCount} / {record.leadAvailableCount} Avail.
          </Tag>
          <div style={{ fontSize: "12px", color: "#888", marginTop: 4 }}>
            Sold: {record.soldCount}
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      key: "status_fields",
      width: 120,
      fixed: "right",
      render: (_, record) => (
        <Tag color={record.status === "available" ? "green" : "volcano"}>
          {record.status?.toUpperCase()}
        </Tag>
      ),
    },
   
    {
      title: "Action",
      key: "topLead",
      width: 120,
      align: "center",
      render: (_, record) => {
        const isSold = record.status === "sold";

        if (isSold) {
          return (
            <Tag
              color="default"
              style={{
                fontWeight: 600,
                padding: "4px 10px",
                borderRadius: 6,
                opacity: 0.6,
                cursor: "not-allowed",
              }}
            >
              Sold
            </Tag>
          );
        }

        if (record.topLead) {
          return (
            <Tag
              color="blue"
              style={{
                fontWeight: 600,
                padding: "4px 10px",
                borderRadius: 6,
              }}
            >
              Top Lead
            </Tag>
          );
        }

        return (
          <Popconfirm
            title="Mark as Top Lead?"
            onConfirm={() => updateTopLead(record._id)}
          >
            <Button size="small">Set Top</Button>
          </Popconfirm>
        );
      },
    },
  ];

  const handleTableChange = (paginationInfo) => {
    fetchAllLeads(paginationInfo.current, paginationInfo.pageSize, searchTerm);
  };

  return (
    <div style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title level={3} style={{ margin: 0 }}>
            All Leads
          </Title>
        </Col>
        <Col>
          <Button type="primary" onClick={() => navigate("/admin/bulk-upload")}>
            Bulk Upload
          </Button>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Card
            style={{ width: "100%", borderRadius: "8px" }}
            bodyStyle={{ padding: 0 }} // Table will touch card edges for a cleaner wide look
            title="Lead Management"
            extra={
              <Input
                placeholder="Search leads..."
                value={searchTerm}
                // onChange={(e) => setSearchTerm(e.target.value)}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  fetchAllLeads(1, pagination.limit, e.target.value); // reset to page 1 when searching
                }}
                prefix={<SearchOutlined style={{ color: "#888" }} />}
                style={{ width: 300 }}
              />
            }
          >
            <Table
              rowKey="_id"
              // rowClassName={(record) => (record.topLead ? "top-lead-row" : "")}
              columns={columns}
              dataSource={leads}
              loading={loading}
              // This ensures the table stretches to the Card width
              // and allows scrolling if the screen gets too small.
              scroll={{ x: "max-content" }}
              pagination={{
                current: pagination.page,
                pageSize: pagination.limit,
                total: pagination.total,
                showTotal: (total) => `Total ${total} leads`,
              }}
              onChange={handleTableChange}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RetailAdminDashboard;
